<template>

  <section

    id="dashboard-ecommerce"

    class="report-tracker-page report-tracker-page--status-wise"

    v-if="$can('read','statuswise_report') || $can('read','report')"

  >

    <b-card no-body class="report-tracker-card">

      <div class="report-toolbar">

        <div

          class="report-toolbar-body"

          :class="{ 'report-toolbar-body--filters-open': showFilters }"

        >

          <div class="report-toolbar-row report-toolbar-row--compact">

            <button

              type="button"

              class="report-filter-toggle"

              :class="{ 'report-filter-toggle--active': showFilters || hasActiveFilters }"

              :aria-expanded="showFilters ? 'true' : 'false'"

              aria-controls="sw-filter-panel"

              @click="showFilters = !showFilters"

            >

              <feather-icon icon="FilterIcon" size="16" />

              <span class="report-filter-toggle-label">Filters</span>

              <span

                v-if="hasActiveFilters"

                class="report-filter-badge"

                :title="`${activeFilterCount} active filter${activeFilterCount === 1 ? '' : 's'}`"

              >

                {{ activeFilterCount }}

              </span>

            </button>



            <div class="report-mode-toggle" role="group" aria-label="Report view">

              <button

                type="button"

                class="report-mode-toggle-btn"

                :class="{ 'report-mode-toggle-btn--active': reportMode === 'single' }"

                @click="setReportMode('single')"

              >

                Single period

              </button>

              <button

                type="button"

                class="report-mode-toggle-btn"

                :class="{ 'report-mode-toggle-btn--active': reportMode === 'comparison' }"

                @click="setReportMode('comparison')"

              >

                Week comparison

              </button>

            </div>



            <div

              v-if="reportMode === 'single'"

              class="report-date-range report-date-range--inline"

            >

              <div class="report-date-range-fields">

                <div class="report-filter-group report-filter-group--date">

                  <label class="report-filter-label" for="sw-start-date">Start</label>

                  <flat-pickr

                    id="sw-start-date"

                    v-model="startDate"

                    class="form-control form-control-sm report-date-input"

                    :config="{ enableTime: false, dateFormat: 'Y-m-d' }"

                  />

                </div>

                <span class="report-date-separator" aria-hidden="true">–</span>

                <div class="report-filter-group report-filter-group--date">

                  <label class="report-filter-label" for="sw-end-date">End</label>

                  <flat-pickr

                    id="sw-end-date"

                    v-model="endDate"

                    class="form-control form-control-sm report-date-input"

                    :config="{ enableTime: false, dateFormat: 'Y-m-d' }"

                  />

                </div>

              </div>

            </div>



            <div

              v-else

              class="report-comparison-period-label"

            >

              <span class="report-filter-label">Comparing</span>

              <span class="report-comparison-period-text">{{ comparisonPeriodLabel }}</span>

            </div>



            <div

              v-if="reportMode === 'comparison'"

              class="report-comparison-group-by"

            >

              <label class="report-filter-label" for="sw-comparison-group">View</label>

              <v-select

                id="sw-comparison-group"

                :value="comparisonGroupBy"

                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"

                :options="comparisonGroupByOptions"

                :reduce="(option) => option.value"

                label="label"

                :clearable="false"

                class="report-v-select report-v-select--comparison-group"

                @input="onComparisonGroupByChange"

              />

            </div>



            <div class="report-toolbar-actions">

              <b-button

                v-if="canDownloadReport && isDownloadReady"

                variant="outline-secondary"

                size="sm"

                @click="downloadReport"

              >

                <feather-icon icon="DownloadIcon" size="14" />

                <span class="d-none d-md-inline">Download</span>

              </b-button>

              <b-button

                v-else-if="canDownloadReport"

                variant="outline-secondary"

                size="sm"

                disabled

                v-b-tooltip.hover

                title="Run Get Report first"

              >

                <feather-icon icon="DownloadIcon" size="14" />

                <span class="d-none d-md-inline">Download</span>

              </b-button>

              <b-button variant="primary" size="sm" @click="getReport">

                <feather-icon icon="BarChart2Icon" size="14" class="mr-50" />

                Get Report

              </b-button>

            </div>

          </div>

        </div>



        <b-collapse id="sw-filter-panel" v-model="showFilters">

          <div class="report-filter-panel">

            <div class="report-filter-grid">

              <div

                v-if="$can('read','manager_filter')"

                class="report-filter-group"

              >

                <label class="report-filter-label" for="sw-mgr">Team lead</label>

                <v-select

                  id="sw-mgr"

                  v-model="mgrSelected"

                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"

                  label="title"

                  :options="accountMgr"

                  :reduce="(option) => option.title"

                  placeholder="All"

                  class="report-v-select"

                />

              </div>

              <div

                v-if="$can('read','recruiter_filter')"

                class="report-filter-group"

              >

                <label class="report-filter-label" for="sw-rec">Recruiter</label>

                <v-select

                  id="sw-rec"

                  v-model="recSelected"

                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"

                  label="title"

                  :options="recruiters"

                  :reduce="(option) => option.title"

                  placeholder="All"

                  class="report-v-select"

                />

              </div>

              <div class="report-filter-group">

                <label class="report-filter-label" for="sw-loc">Location</label>

                <v-select

                  id="sw-loc"

                  v-model="locSelected"

                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"

                  label="title"

                  :options="location"

                  :reduce="(option) => option.title"

                  placeholder="All"

                  class="report-v-select"

                />

              </div>

              <div class="report-filter-group">

                <label class="report-filter-label" for="sw-client">Client</label>

                <v-select

                  id="sw-client"

                  v-model="clientSelected"

                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"

                  label="title"

                  :options="clients"

                  :reduce="(option) => option.title"

                  placeholder="All"

                  class="report-v-select"

                />

              </div>

              <div class="report-filter-group">

                <label class="report-filter-label" for="sw-source">Source</label>

                <v-select

                  id="sw-source"

                  v-model="sourceSelected"

                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"

                  label="title"

                  :options="sources"

                  :reduce="(option) => option.title"

                  placeholder="All"

                  class="report-v-select"

                />

              </div>

              <div class="report-filter-group">

                <label class="report-filter-label" for="sw-emp-status">Employee status</label>

                <v-select

                  id="sw-emp-status"

                  v-model="empStatusSelected"

                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"

                  label="title"

                  :options="empStatusOptions"

                  :reduce="(option) => option.title"

                  placeholder="All"

                  class="report-v-select"

                />

              </div>

              <div class="report-filter-group">

                <label class="report-filter-label" for="sw-vertical">Vertical</label>

                <v-select

                  id="sw-vertical"

                  v-model="verticalSelected"

                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"

                  label="title"

                  :options="verticalOptions"

                  :reduce="(option) => option.title"

                  placeholder="All"

                  class="report-v-select"

                />

              </div>

              <div class="report-filter-group">

                <label class="report-filter-label" for="sw-category">Category</label>

                <v-select

                  id="sw-category"

                  v-model="categorySelected"

                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"

                  label="title"

                  :options="categoryOptions"

                  :reduce="(option) => option.title"

                  placeholder="All"

                  class="report-v-select"

                />

              </div>

            </div>



            <div class="report-filter-panel-divider" />



            <div class="report-advanced-grid">

              <div class="report-advanced-card">

                <h6 class="report-section-heading">Group by dimensions</h6>

                <p class="report-dimension-purpose">

                  Track how many positions you have, whether recruiters are actively working them, and if each position is open or closed in the selected period.

                </p>

                <b-form-checkbox-group

                  v-model="selected"

                  :options="options"

                  name="sw-dimensions"

                  class="report-dimension-checks report-dimension-checks--grid"

                />

              </div>

              <div class="report-advanced-card report-advanced-card--pipeline">

                <h6 class="report-section-heading">Pipeline status filter</h6>

                <div class="report-pipeline-toggle">

                  <b-form-checkbox

                    v-model="showDetailedColumns"

                    switch

                    class="report-detailed-columns-switch"

                  >

                    Show detailed status columns

                  </b-form-checkbox>

                </div>

                <p class="report-pipeline-hint">

                  Only applies when &lsquo;Show detailed status columns&rsquo; is enabled

                </p>

                <label class="report-filter-label report-filter-label--pipeline" for="sw-pipeline-status">

                  Pipeline statuses (for detailed columns)

                </label>

                <v-select

                  id="sw-pipeline-status"

                  v-model="statusSelected"

                  :options="statusOptions"

                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"

                  label="title"

                  :reduce="(option) => option.title"

                  multiple

                  :close-on-select="false"

                  placeholder="All pipeline statuses"

                  class="report-v-select report-v-select--advanced report-v-select--pipeline-multi"

                />

              </div>

            </div>

          </div>

        </b-collapse>



        <div v-if="hasFetched" class="report-toolbar-context">

          <feather-icon icon="FilterIcon" size="14" class="report-context-icon" />

          <span class="report-context-text">{{ contextSummary }}</span>

          <template v-if="!isComparisonMode && positionSummary.total > 0">

            <b-badge pill variant="light-primary" class="report-position-chip">

              {{ positionSummary.total }} position{{ positionSummary.total === 1 ? '' : 's' }}

            </b-badge>

            <b-badge

              v-if="positionSummary.open > 0"

              pill

              variant="light-success"

              class="report-position-chip report-position-chip--filter"

              :class="{ 'report-position-chip--active': positionStatusFilter === 'open' }"

              role="button"

              tabindex="0"

              title="Show open positions only"

              @click="togglePositionStatusFilter('open')"

            >

              {{ positionSummary.open }} open

            </b-badge>

            <b-badge

              v-if="positionSummary.closed > 0"

              pill

              variant="light-secondary"

              class="report-position-chip report-position-chip--filter"

              :class="{ 'report-position-chip--active': positionStatusFilter === 'closed' }"

              role="button"

              tabindex="0"

              title="Show closed positions only"

              @click="togglePositionStatusFilter('closed')"

            >

              {{ positionSummary.closed }} closed

            </b-badge>

            <b-badge

              v-if="positionSummary.unknown > 0"

              pill

              variant="light-warning"

              class="report-position-chip report-position-chip--filter"

              :class="{ 'report-position-chip--active': positionStatusFilter === 'unknown' }"

              role="button"

              tabindex="0"

              title="Positions without ATS job status — pipeline activity alone cannot confirm open vs closed"

              @click="togglePositionStatusFilter('unknown')"

            >

              {{ positionSummary.unknown }} unknown

            </b-badge>

            <b-badge

              v-if="positionSummary.active > 0"

              pill

              variant="light-info"

              class="report-position-chip"

            >

              {{ positionSummary.active }} w/ activity

            </b-badge>

            <b-badge

              v-if="positionSummary.noClosure > 0"

              pill

              variant="light-danger"

              class="report-position-chip report-position-chip--filter"

              :class="{ 'report-position-chip--active': positionStatusFilter === 'noClosure' }"

              role="button"

              tabindex="0"

              title="Open positions created over 30 days ago with zero Joined — ask Account Managers why there is no closure"

              @click="togglePositionStatusFilter('noClosure')"

            >

              {{ positionSummary.noClosure }} no closure

            </b-badge>

            <b-badge

              v-if="positionSummary.noActivity > 0"

              pill

              variant="light-warning"

              class="report-position-chip"

            >

              {{ positionSummary.noActivity }} no activity

            </b-badge>

            <b-badge

              v-if="positionStatusFilter"

              pill

              variant="outline-secondary"

              class="report-position-chip report-position-chip--filter report-position-chip--clear"

              role="button"

              tabindex="0"

              title="Clear position status filter"

              @click="positionStatusFilter = null"

            >

              Clear filter

            </b-badge>

          </template>

          <b-badge v-if="hasReportContent" pill variant="light-primary" class="report-context-count">

            {{ isComparisonMode ? comparisonRows.length : displayData.length }} rows

          </b-badge>

        </div>

      </div>



      <div v-if="loading" class="report-loading-state">

        <b-spinner small variant="primary" />

        <span>Loading report…</span>

      </div>



      <div v-else-if="reportStatus && !hasReportContent" class="report-error-state">

        <feather-icon icon="AlertCircleIcon" size="36" class="report-error-icon text-danger" />

        <p class="report-empty-title text-danger mb-0">{{ reportStatus }}</p>

      </div>



      <div v-else-if="hasFetched && !hasReportContent" class="report-empty-state">

        <feather-icon icon="InboxIcon" size="40" class="report-empty-icon" />

        <h5 class="report-empty-title">No data for selected filters</h5>

        <p class="report-empty-hint">Try adjusting the date range or clearing filter selections, then run the report again.</p>

      </div>



      <div v-else-if="isComparisonMode && comparisonRows.length" class="report-table-wrap">

        <b-table

          :items="comparisonRows"

          :fields="comparisonTableFields"

          hover

          striped

          class="report-table mb-0"

          show-empty

        >

          <template #cell(current)="data">

            {{ formatComparisonCell(data.item.current) }}

          </template>

          <template #cell(previous)="data">

            {{ formatComparisonCell(data.item.previous) }}

          </template>

          <template #cell(change)="data">

            <span

              class="report-comparison-delta"

              :class="comparisonDeltaClass(data.item.change)"

            >

              {{ formatComparisonDelta(data.item.change) }}

            </span>

          </template>

          <template #cell(changePct)="data">

            <span

              class="report-comparison-delta"

              :class="comparisonDeltaClass(data.item.change)"

            >

              {{ formatComparisonDeltaPct(data.item.changePct) }}

            </span>

          </template>

          <template v-for="metric in comparisonMetricDefs" #[`cell(${metric.key})`]="data">

            <div

              :key="metric.key"

              class="report-comparison-metric-cell"

            >

              <span>{{ formatComparisonCell(data.item[metric.key]) }}</span>

              <span

                v-if="showComparisonInlineDelta(data.item, metric.key)"

                class="report-comparison-delta report-comparison-delta--inline"

                :class="comparisonDeltaClass(getComparisonMetricChange(data.item, metric.key))"

              >

                {{ formatComparisonInlineDelta(data.item, metric.key) }}

              </span>

            </div>

          </template>

        </b-table>

      </div>



      <div v-else-if="displayData.length" class="report-table-wrap">

        <b-table

          :items="displayData"

          :fields="tableFields"

          hover

          striped

          class="report-table mb-0"

          show-empty

        >

          <template #cell(Date)="data">

            {{ data.item.Date || '—' }}

          </template>

          <template #cell(Source)="data">

            {{ data.item.Source || '—' }}

          </template>

          <template #cell(Client)="data">

            <div class="report-job-hierarchy">

              <span class="report-job-client-name">{{ getRowClient(data.item) || '—' }}</span>

              <template v-if="selected.includes('position_name')">

                <span

                  v-if="data.item.JobIdDisplay"

                  class="report-job-id"

                >

                  Job #{{ data.item.JobIdDisplay }}

                </span>

                <span

                  v-if="data.item.PositionCreatedDate"

                  class="report-job-created"

                >

                  Created {{ data.item.PositionCreatedDate }}

                </span>

                <span

                  v-if="data.item.DaysOpen != null"

                  class="report-job-days-open"

                  :class="{

                    'report-job-days-open--stale': data.item.DaysOpen > NO_CLOSURE_DAYS_THRESHOLD || data.item.NoClosure,

                  }"

                >

                  {{ data.item.DaysOpen }} day{{ data.item.DaysOpen === 1 ? '' : 's' }} open

                </span>

              </template>

            </div>

          </template>

          <template #cell(PositionName)="data">

            <div class="report-job-hierarchy">

              <span class="report-job-position-name">{{ data.item.PositionName || '—' }}</span>

              <div class="report-position-badges">

                <b-badge

                  v-if="data.item.PositionStatus"

                  pill

                  :variant="positionStatusVariant(data.item)"

                  class="report-status-badge"

                  v-b-tooltip.hover

                  title="Open/Closed/On Hold comes from ATS job status. Unknown means job status is missing in this report."

                >

                  {{ data.item.PositionStatus }}

                </b-badge>

                <b-badge

                  v-if="data.item.NoClosure"

                  pill

                  variant="light-danger"

                  class="report-no-closure-badge"

                >

                  No closure

                </b-badge>

              </div>

            </div>

          </template>

          <template #cell(Recruiter)="data">

            <span

              class="report-recruiter-name"

              :title="data.item.Recruiter || ''"

            >{{ data.item.Recruiter || '—' }}</span>

          </template>

        </b-table>

      </div>

    </b-card>

  </section>

</template>



<script>

import {

  BCard,

  BButton,

  BSpinner,

  BFormCheckbox,

  BFormCheckboxGroup,

  BTable,

  BBadge,

  BCollapse,

  VBTooltip,

} from 'bootstrap-vue'

import flatPickr from 'vue-flatpickr-component'

import vSelect from 'vue-select'

import moment from 'moment'

import UserService from '@/services/user-service'

import clientService from '@/services/client-service'

import reportService from '@/services/report-service'

import JobService from '@/services/job-service'

import adminConfigService from '@/services/admin-config-service'

import { resolveJobScopeUser } from '@/views/apps/jobs/job-list-helpers'

import {
  buildReportFilename,
  cleanExportDaysOpen,
  cleanExportJobId,
  cleanExportText,
  downloadBase64Excel,
  exportTableToExcel,
} from '@/utils/report-download'

import {
  aggregateByClient,
  aggregateByClientPosition,
  aggregateOverall,
  buildOverallComparisonRows,
  buildWeekWiseComparisonRows,
  COMPARISON_METRICS,
  deltaVariant,
  formatComparisonPeriodRange,
  formatDeltaPct,
  formatDeltaValue,
  formatInlineDelta,
  getMonSatWeekRange,
  getPreviousWeekRange,
} from '@/utils/status-wise-comparison'



// Default group-by: position visibility first for "how many positions / actively working / open vs closed"
const DEFAULT_DIMENSIONS = ['position_name', 'recruiter', 'client']

// Pipeline metrics used to infer recruiter activity when backend omits IsActive / WorkingStatus
const PIPELINE_ACTIVITY_KEYS = [
  'TotalCandidates',
  'ProfileShared',
  'Interview',
  'Shortlisted',
  'Offered',
  'NotOffered',
  'OfferDrop',
  'Joined',
  'ReviewReject',
  'Initiated',
  'NotInterested',
  'NotRelevant',
  'NotAnswered',
  'NotReachable',
  'WrongNumber',
  'CallBack',
  'ScreenSelect',
  'ScreenReject',
  'Duplicate',
  'InProcess',
  'Inprocess',
  'OnHold',
  'Rejected',
  'NoShow',
  'Confirmed',
  'Drop',
  'LOIIssued',
  'Attrition',
  'EarlyAttrition',
]

/*
 * status-wise-tracker may omit job status / vertical / category on older backends.
 * Frontend hydrates from the payload when those fields exist, otherwise one cached
 * GET jobs/list (see enrichJobStatuses) keyed by job_id or client+position name.
 */
const ATS_JOB_STATUSES = 'Active,Approval Pending,On Hold,Closed,Cancelled,Draft,Target Date Breached'

// Positions open longer than this with zero Joined are flagged for HR follow-up
const NO_CLOSURE_DAYS_THRESHOLD = 30

const MAX_REPORT_RANGE_DAYS = 92

const DEFAULT_VERTICAL_OPTIONS = [{ title: 'Service Industry' }, { title: 'Infra Industry' }]

const DEFAULT_CATEGORY_OPTIONS = [{ title: 'White Collar' }, { title: 'Blue Collar' }]

const JOB_META_TTL_MS = 5 * 60 * 1000

let jobMetaCache = { byJobId: {}, byName: {}, byClientPosition: {}, fetchedAt: 0 }

let jobMetaInflight = null

function trackerRowsHaveJobFields(rows) {
  if (!Array.isArray(rows) || !rows.length) return false
  const sample = rows.slice(0, Math.min(rows.length, 12))
  return sample.some(row => row.Category || row.category || row.Vertical || row.vertical || row.job_id || row.PositionStatus || row.position_status)
}

function normalizePersonName(value) {
  return String(value || '').replace(/\s+/g, ' ').trim()
}

function pickRecruiterFromValue(value) {
  if (value == null || value === '') return ''
  if (Array.isArray(value)) {
    return [...new Set(value.map(item => pickRecruiterFromValue(item)).filter(Boolean))].join(', ')
  }
  if (typeof value === 'object') {
    return normalizePersonName(value.title || value.name || value.recruiter_name || value.fullName || '')
  }
  const text = String(value).trim()
  if (text.startsWith('{') || text.startsWith('[')) {
    try {
      return pickRecruiterFromValue(JSON.parse(text))
    } catch (e) {
      return normalizePersonName(text)
    }
  }
  return normalizePersonName(text)
}

function pickRowRecruiter(row) {
  if (!row) return ''
  return pickRecruiterFromValue(
    row.Recruiter ?? row.recruiter_name ?? row.RecruiterName ?? row.rec_name ?? row.recruiter,
  )
}

function pickRowSource(row) {
  if (!row) return ''
  const raw = row.Source ?? row.source ?? row.CandidateSource ?? row.candidate_source ?? row.source_name
  if (raw == null || raw === '') return ''
  return String(raw).trim()
}

function pickRowActivityDate(row) {
  if (!row) return ''
  const raw = row.Date ?? row.date ?? row.ReportDate ?? row.report_date
    ?? row.updatedAt ?? row.UpdatedAt ?? row.activityDate ?? row.activity_date
  if (raw == null || raw === '' || raw === '—') return ''
  return raw
}

function rowsHaveSourceValues(rows) {
  return Array.isArray(rows) && rows.some(row => pickRowSource(row))
}

function rowsHaveActivityDates(rows) {
  return Array.isArray(rows) && rows.some(row => pickRowActivityDate(row))
}

function listDateRangeDays(startDate, endDate) {
  const days = []
  const cursor = moment(startDate)
  const end = moment(endDate)
  if (!cursor.isValid() || !end.isValid()) return days
  while (cursor.isSameOrBefore(end, 'day')) {
    days.push(cursor.format('YYYY-MM-DD'))
    cursor.add(1, 'day')
  }
  return days
}



const STATUS_COL_ALIGN = { thClass: 'text-right', tdClass: 'text-right numeric-col' }

function statusCol(key, label) {
  return { key, label, sortable: true, ...STATUS_COL_ALIGN }
}

// Official pipeline from ProfileShared through Attrition + Early Attrition (tracker/API keys).
const PIPELINE_STATUS_COLUMNS = [
  statusCol('ProfileShared', 'Profile Shared'),
  statusCol('ScreenSelect', 'Screen Select'),
  statusCol('ScreenReject', 'Screen Reject'),
  statusCol('Interview', 'Interview'),
  statusCol('NoShow', 'No Show'),
  statusCol('Duplicate', 'Duplicate'),
  statusCol('InProcess', 'In Process'),
  statusCol('OnHold', 'On Hold'),
  statusCol('Shortlisted', 'Shortlisted'),
  statusCol('Rejected', 'Rejected'),
  statusCol('Drop', 'Drop'),
  statusCol('LOIIssued', 'LOI Issued'),
  statusCol('Offered', 'Offered'),
  statusCol('NotOffered', 'Not Offered'),
  statusCol('OfferDrop', 'Offer Drop'),
  statusCol('Joined', 'Joined'),
  statusCol('Attrition', 'Attrition'),
  statusCol('EarlyAttrition', 'Early Attrition'),
]

const PRE_PIPELINE_STATUS_COLUMNS = [
  statusCol('ReviewReject', 'Review Reject'),
  statusCol('Initiated', 'Initiated'),
  statusCol('NotInterested', 'Not Interested'),
  statusCol('NotRelevant', 'Not Relevant'),
  statusCol('NotAnswered', 'Not Answered'),
  statusCol('NotReachable', 'Not Reachable'),
  statusCol('WrongNumber', 'Wrong Number'),
  statusCol('CallBack', 'Call Back'),
]

const DETAILED_STATUS_COLUMNS = [...PIPELINE_STATUS_COLUMNS, ...PRE_PIPELINE_STATUS_COLUMNS]

const DEFAULT_STATUS_SELECTED = [
  'ProfileShared',
  'ScreenSelect',
  'ScreenReject',
  'Interview',
  'No Show',
  'Duplicate',
  'Inprocess',
  'OnHold',
  'Shortlisted',
  'Rejected',
  'Drop',
  'LOI Issued',
  'Offered',
  'NotOffered',
  'OfferDrop',
  'Joined',
  'Attrition',
  'Early Attrition',
]

const STATUS_COLUMN_MAP = {
  ReviewReject: 'ReviewReject',
  Initiated: 'Initiated',
  'Not Interested': 'NotInterested',
  NotInterested: 'NotInterested',
  'Not Relevant': 'NotRelevant',
  NotRelevant: 'NotRelevant',
  'Not Answered': 'NotAnswered',
  NotAnswered: 'NotAnswered',
  'Not Reachable': 'NotReachable',
  NotReachable: 'NotReachable',
  'Wrong Number': 'WrongNumber',
  WrongNumber: 'WrongNumber',
  'Call Back': 'CallBack',
  CallBack: 'CallBack',
  ProfileShared: 'ProfileShared',
  Interview: 'Interview',
  'No Show': 'NoShow',
  NoShow: 'NoShow',
  ScreenSelect: 'ScreenSelect',
  ScreenReject: 'ScreenReject',
  Drop: 'Drop',
  Inprocess: 'InProcess',
  InProcess: 'InProcess',
  OnHold: 'OnHold',
  Shortlisted: 'Shortlisted',
  Duplicate: 'Duplicate',
  Rejected: 'Rejected',
  NotOffered: 'NotOffered',
  Offered: 'Offered',
  OfferDrop: 'OfferDrop',
  Joined: 'Joined',
  'LOI Issued': 'LOIIssued',
  LOIIssued: 'LOIIssued',
  Attrition: 'Attrition',
  'Early Attrition': 'EarlyAttrition',
  EarlyAttrition: 'EarlyAttrition',
}

const STATUS_FIELD_ALIASES = {
  ProfileShared: ['ProfileShared', 'profile_shared', 'profileShared'],
  ScreenSelect: ['ScreenSelect', 'screen_select', 'Screen Select'],
  ScreenReject: ['ScreenReject', 'screen_reject', 'Screen Reject'],
  Interview: ['Interview', 'interview'],
  NoShow: ['NoShow', 'No Show', 'no_show'],
  Duplicate: ['Duplicate', 'duplicate'],
  InProcess: ['InProcess', 'Inprocess', 'in_process', 'In Process'],
  OnHold: ['OnHold', 'On Hold', 'on_hold'],
  Shortlisted: ['Shortlisted', 'shortlisted'],
  Rejected: ['Rejected', 'rejected'],
  Drop: ['Drop', 'drop'],
  LOIIssued: ['LOIIssued', 'LOI Issued', 'loi_issued'],
  Offered: ['Offered', 'offered'],
  NotOffered: ['NotOffered', 'Not Offered', 'not_offered'],
  OfferDrop: ['OfferDrop', 'Offer Drop', 'offer_drop'],
  Joined: ['Joined', 'joined'],
  Attrition: ['Attrition', 'attrition'],
  EarlyAttrition: ['EarlyAttrition', 'Early Attrition', 'early_attrition'],
  ReviewReject: ['ReviewReject', 'review_reject'],
  Initiated: ['Initiated', 'initiated'],
  NotInterested: ['NotInterested', 'Not Interested', 'not_interested'],
  NotRelevant: ['NotRelevant', 'Not Relevant', 'not_relevant'],
  NotAnswered: ['NotAnswered', 'Not Answered', 'not_answered'],
  NotReachable: ['NotReachable', 'Not Reachable', 'not_reachable'],
  WrongNumber: ['WrongNumber', 'Wrong Number', 'wrong_number'],
  CallBack: ['CallBack', 'Call Back', 'call_back'],
}

function pickStatusCount(row, columnKey) {
  if (!row) return 0
  const aliases = STATUS_FIELD_ALIASES[columnKey] || [columnKey]
  const sources = [row]
  if (row.statuses && typeof row.statuses === 'object') sources.push(row.statuses)
  if (row.statusCounts && typeof row.statusCounts === 'object') sources.push(row.statusCounts)
  if (row.status_counts && typeof row.status_counts === 'object') sources.push(row.status_counts)
  for (let i = 0; i < sources.length; i += 1) {
    const src = sources[i]
    for (let j = 0; j < aliases.length; j += 1) {
      const raw = src[aliases[j]]
      if (raw != null && raw !== '') {
        const n = Number(raw)
        if (Number.isFinite(n)) return n
      }
    }
  }
  return 0
}




export default {

  components: {

    BCard,

    BButton,

    BSpinner,

    flatPickr,

    BFormCheckbox,

    BFormCheckboxGroup,

    BTable,

    vSelect,

    BBadge,

    BCollapse,

  },

  directives: {

    'b-tooltip': VBTooltip,

  },

  data() {

    return {

      startDate: '',

      endDate: '',

      compiledData: [],

      loading: false,

      hasFetched: false,

      recruiters: [],

      recSelected: null,

      accountMgr: [],

      mgrSelected: null,

      sourceSelected: null,

      clients: [],

      clientSelected: null,

      location: [{ title: 'Pune' }, { title: 'Delhi' }],

      sources: [

        { title: 'Naukri' },

        { title: 'Monster' },

        { title: 'ATS' },

        { title: 'LinkedIn' },

        { title: 'Indeed' },

        { title: 'Shine' },

        { title: 'TimesJobs' },

        { title: 'IIMJobs' },

        { title: 'Glassdoor' },

        { title: 'FreshersWorld' },

        { title: 'Other' },

        { title: 'Train N Hire' },

        { title: 'Internal' },

        { title: 'Referenced' },

      ],

      locSelected: null,

      reportStatus: '',

      filename: '',

      downloadFile: '',

      selected: [...DEFAULT_DIMENSIONS],

      options: [

        { text: 'Recruiter', value: 'recruiter' },

        { text: 'Team Lead', value: 'manager' },

        { text: 'Location', value: 'location' },

        { text: 'Client', value: 'client' },

        { text: 'Source', value: 'source' },

        { text: 'Position', value: 'position_name' },

        { text: 'Date', value: 'date' },

        { text: 'Vertical', value: 'vertical' },

        { text: 'Category', value: 'category' },

      ],

      statusOptions: [

        { title: 'ProfileShared' },

        { title: 'ScreenSelect' },

        { title: 'ScreenReject' },

        { title: 'Interview' },

        { title: 'No Show' },

        { title: 'Duplicate' },

        { title: 'Inprocess' },

        { title: 'OnHold' },

        { title: 'Shortlisted' },

        { title: 'Rejected' },

        { title: 'Drop' },

        { title: 'LOI Issued' },

        { title: 'Offered' },

        { title: 'NotOffered' },

        { title: 'OfferDrop' },

        { title: 'Joined' },

        { title: 'Attrition' },

        { title: 'Early Attrition' },

        { title: 'ReviewReject' },

        { title: 'Initiated' },

        { title: 'Not Interested' },

        { title: 'Not Relevant' },

        { title: 'Not Answered' },

        { title: 'Not Reachable' },

        { title: 'Wrong Number' },

        { title: 'Call Back' },

      ],

      statusSelected: [...DEFAULT_STATUS_SELECTED],

      empStatusOptions: [{ title: 'ACTIVE' }, { title: 'INACTIVE' }],

      empStatusSelected: null,

      verticalSelected: null,

      categorySelected: null,

      verticalOptions: [...DEFAULT_VERTICAL_OPTIONS],

      categoryOptions: [...DEFAULT_CATEGORY_OPTIONS],

      jobMetaByClientPosition: {},

      rangeWarning: '',

      showFilters: false,

      showDetailedColumns: false,

      NO_CLOSURE_DAYS_THRESHOLD,

      jobMetaByJobId: {},

      jobMetaByPositionName: {},

      positionStatusFilter: null,

      reportMode: 'single',

      comparisonGroupBy: 'overall',

      comparisonPositionWise: false,

      comparisonGroupByOptions: [
        { label: 'Overall totals', value: 'overall' },
        { label: 'By client', value: 'client' },
      ],

      comparisonRows: [],

      comparisonPeriods: null,

      comparisonMetricDefs: COMPARISON_METRICS,

    }

  },

  computed: {

    isComparisonMode() {

      return this.reportMode === 'comparison'

    },

    hasReportContent() {

      if (this.isComparisonMode) return this.comparisonRows.length > 0

      return this.displayData.length > 0

    },

    comparisonPeriodLabel() {

      const periods = this.comparisonPeriods || {}

      const current = periods.current || getMonSatWeekRange()

      const previous = periods.previous || getPreviousWeekRange(current.start, current.end)

      return `This week (${this.formatDisplayDate(current.start)} – ${this.formatDisplayDate(current.end)}) vs Last week (${this.formatDisplayDate(previous.start)} – ${this.formatDisplayDate(previous.end)})`

    },

    comparisonTableFields() {

      const periods = this.comparisonPeriods || {}

      const current = periods.current || getMonSatWeekRange()

      const previous = periods.previous || getPreviousWeekRange(current.start, current.end)

      if (this.comparisonGroupBy === 'client') {

        const fields = [

          { key: 'groupLabel', label: 'Client', sortable: true },

        ]

        if (this.comparisonPositionWise) {

          fields.push({ key: 'positionLabel', label: 'Position', sortable: true })

        }

        fields.push({ key: 'weekLabel', label: 'Week', sortable: true })

        COMPARISON_METRICS.forEach(metric => {

          fields.push({

            key: metric.key,

            label: metric.label,

            sortable: true,

            thClass: 'text-right',

            tdClass: 'text-right numeric-col',

          })

        })

        return fields

      }

      return [

        { key: 'metricLabel', label: 'Metric', sortable: true },

        {

          key: 'current',

          label: `This week (${this.formatDisplayDate(current.start)} – ${this.formatDisplayDate(current.end)})`,

          sortable: true,

          thClass: 'text-right',

          tdClass: 'text-right numeric-col',

        },

        {

          key: 'previous',

          label: `Last week (${this.formatDisplayDate(previous.start)} – ${this.formatDisplayDate(previous.end)})`,

          sortable: true,

          thClass: 'text-right',

          tdClass: 'text-right numeric-col',

        },

        { key: 'change', label: 'Change', sortable: true, thClass: 'text-right', tdClass: 'text-right numeric-col' },

        { key: 'changePct', label: 'Change %', sortable: true, thClass: 'text-right', tdClass: 'text-right numeric-col' },

      ]

    },

    mappedData() {

      if (!Array.isArray(this.compiledData) || !this.compiledData.length) return []

      return this.compiledData.map(row => this.mapRow(row))

    },

    displayGroupingMode() {

      const extraDims = this.selected.includes('source')

        || this.selected.includes('date')

        || this.selected.includes('vertical')

        || this.selected.includes('category')

      // Recruiter on (or filtered): collapse to selected dimensions so a hidden
      // API grain (position / job / whitespace) does not repeat the same recruiter.

      if (this.recSelected || this.selected.includes('recruiter')) {

        return 'selected'

      }

      if (extraDims) return 'selected'

      if (this.selected.includes('position_name')) return 'client_position'

      return 'client'

    },

    filteredMappedData() {

      if (!this.mappedData.length) return []

      let rows = this.mappedData

      const vertical = this.normalizeFilterValue(this.verticalSelected)

      const category = this.normalizeFilterValue(this.categorySelected)

      if (vertical) {

        rows = rows.filter(row => this.normalizeFilterValue(row.Vertical) === vertical)

      }

      if (category) {

        rows = rows.filter(row => this.normalizeFilterValue(row.Category) === category)

      }

      return rows

    },

    displayData() {

      if (!this.filteredMappedData.length) return []

      let rows = this.filteredMappedData

      if (this.positionStatusFilter) {

        rows = rows.filter(row => {

          if (this.positionStatusFilter === 'noClosure') return row.NoClosure === true

          const closed = this.isPositionClosed(row)

          if (this.positionStatusFilter === 'closed') return closed === true

          if (this.positionStatusFilter === 'open') return closed === false

          if (this.positionStatusFilter === 'unknown') return closed === null

          return true

        })

      }

      const mode = this.displayGroupingMode

      if (mode === 'none') return rows

      return this.aggregateDisplayRows(rows, mode)

    },

    dimensionFields() {

      const fields = []

      if (this.selected.includes('date')) {

        fields.push({ key: 'Date', label: 'Date', sortable: true })

      }

      if (this.selected.includes('client')) {

        fields.push({ key: 'Client', label: 'Client', sortable: true })

      }

      if (this.selected.includes('position_name')) {

        fields.push({ key: 'PositionName', label: 'Position', sortable: true })

      }

      if (this.selected.includes('recruiter')) {

        fields.push({

          key: 'Recruiter',

          label: 'Recruiter',

          sortable: true,

          thClass: 'report-recruiter-col',

          tdClass: 'report-recruiter-col',

        })

      }

      if (this.selected.includes('manager')) {

        fields.push({ key: 'Manager', label: 'Team Lead', sortable: true })

      }

      if (this.selected.includes('location')) {

        fields.push({ key: 'Location', label: 'Location', sortable: true })

      }

      if (this.selected.includes('source')) {

        fields.push({ key: 'Source', label: 'Source', sortable: true })

      }

      if (this.selected.includes('vertical')) {

        fields.push({ key: 'Vertical', label: 'Vertical', sortable: true })

      }

      if (this.selected.includes('category')) {

        fields.push({ key: 'Category', label: 'Category', sortable: true })

      }

      return fields

    },

    defaultMetricFields() {

      return [

        { key: 'TotalCandidates', label: 'Total Candidates', sortable: true, thClass: 'text-right', tdClass: 'text-right numeric-col' },

        { key: 'ProfileShared', label: 'Profile Shared', sortable: true, thClass: 'text-right', tdClass: 'text-right numeric-col' },

        { key: 'Interview', label: 'Interview', sortable: true, thClass: 'text-right', tdClass: 'text-right numeric-col' },

        { key: 'Shortlisted', label: 'Shortlisted', sortable: true, thClass: 'text-right', tdClass: 'text-right numeric-col' },

        { key: 'Offered', label: 'Offered', sortable: true, thClass: 'text-right', tdClass: 'text-right numeric-col' },

        { key: 'NotOfferedDrop', label: 'Not Offered / Drop', sortable: true, thClass: 'text-right', tdClass: 'text-right numeric-col' },

        { key: 'Joined', label: 'Joined', sortable: true, thClass: 'text-right', tdClass: 'text-right numeric-col' },

        { key: 'Revenue', label: 'Revenue', sortable: true, thClass: 'text-right', tdClass: 'text-right numeric-col text-muted-col' },

      ]

    },

    detailedFields() {

      if (!this.showDetailedColumns) return []

      const selected = Array.isArray(this.statusSelected) ? this.statusSelected : []

      if (!selected.length) return PIPELINE_STATUS_COLUMNS

      const seen = new Set()

      const fields = []

      selected.forEach(status => {

        const key = STATUS_COLUMN_MAP[status] || status

        if (!key || seen.has(key)) return

        seen.add(key)

        const col = DETAILED_STATUS_COLUMNS.find(item => item.key === key)

        fields.push(col || statusCol(key, status))

      })

      return fields

    },

    tableFields() {

      if (this.showDetailedColumns && this.detailedFields.length) {

        const total = this.defaultMetricFields.find(f => f.key === 'TotalCandidates')

        const revenue = this.defaultMetricFields.find(f => f.key === 'Revenue')

        return [...this.dimensionFields, total, ...this.detailedFields, revenue].filter(Boolean)

      }

      return [...this.dimensionFields, ...this.defaultMetricFields]

    },

    contextSummary() {

      if (this.isComparisonMode) {

        const parts = [this.comparisonPeriodLabel]

        if (this.comparisonGroupBy === 'client') {

          parts.push(this.comparisonPositionWise ? 'Grouped by client · position-wise' : 'Grouped by client')

        }

        if (this.mgrSelected) parts.push(`Team Lead: ${this.mgrSelected}`)

        if (this.recSelected) parts.push(`Recruiter: ${this.recSelected}`)

        if (this.clientSelected) parts.push(`Client: ${this.clientSelected}`)

        if (this.locSelected) parts.push(`Location: ${this.locSelected}`)

        if (this.sourceSelected) parts.push(`Source: ${this.sourceSelected}`)

        if (this.empStatusSelected) parts.push(`Employee: ${this.empStatusSelected}`)

        if (this.verticalSelected) parts.push(`Vertical: ${this.verticalSelected}`)

        if (this.categorySelected) parts.push(`Category: ${this.categorySelected}`)

        return parts.join(' · ')

      }

      const parts = [`${this.formatDisplayDate(this.startDate)} – ${this.formatDisplayDate(this.endDate)}`]

      if (this.rangeWarning) parts.unshift(this.rangeWarning)

      if (this.mgrSelected) parts.push(`Team Lead: ${this.mgrSelected}`)

      if (this.recSelected) parts.push(`Recruiter: ${this.recSelected}`)

      if (this.clientSelected) parts.push(`Client: ${this.clientSelected}`)

      if (this.locSelected) parts.push(`Location: ${this.locSelected}`)

      if (this.sourceSelected) parts.push(`Source: ${this.sourceSelected}`)

      if (this.empStatusSelected) parts.push(`Employee: ${this.empStatusSelected}`)

      if (this.verticalSelected) parts.push(`Vertical: ${this.verticalSelected}`)

      if (this.categorySelected) parts.push(`Category: ${this.categorySelected}`)

      if (this.showDetailedColumns) {

        const n = this.detailedFields.length

        parts.push(n ? `${n} detailed status columns` : 'Detailed status columns on')

      }

      if (this.positionSummary.total > 0) {

        const parts2 = [`${this.positionSummary.total} positions`]

        if (this.positionSummary.open > 0) parts2.push(`${this.positionSummary.open} open`)

        if (this.positionSummary.closed > 0) parts2.push(`${this.positionSummary.closed} closed`)

        if (this.positionSummary.unknown > 0) parts2.push(`${this.positionSummary.unknown} unknown`)

        if (this.positionSummary.active > 0) parts2.push(`${this.positionSummary.active} w/ activity`)

        if (this.positionSummary.noClosure > 0) parts2.push(`${this.positionSummary.noClosure} no closure`)

        parts.push(parts2.join(' · '))

      } else if (this.hasFetched && !this.selected.includes('position_name')) {

        parts.push('Enable Position in Group by to see position counts')

      }

      return parts.join(' · ')

    },

    positionSummary() {

      const rows = this.filteredMappedData.filter(row => this.getPositionKey(row))

      if (!rows.length) {

        return { total: 0, active: 0, closed: 0, open: 0, unknown: 0, noActivity: 0, noClosure: 0 }

      }

      const positionMap = new Map()

      rows.forEach(row => {

        const key = this.getPositionKey(row)

        if (!positionMap.has(key)) {

          positionMap.set(key, {

            closed: this.isPositionClosed(row),

            hasActivity: false,

            noClosure: this.hasNoClosure(row),

          })

        }

        const entry = positionMap.get(key)

        const closed = this.isPositionClosed(row)

        if (closed === true) entry.closed = true

        else if (closed === false && entry.closed !== true) entry.closed = false

        if (this.hasPipelineActivity(row)) entry.hasActivity = true

        if (this.numVal(row.Joined) > 0) entry.noClosure = false

      })

      let active = 0

      let closed = 0

      let open = 0

      let unknown = 0

      let noActivity = 0

      let noClosure = 0

      positionMap.forEach(entry => {

        if (entry.closed === true) {

          closed += 1

        } else if (entry.closed === false) {

          open += 1

          if (entry.hasActivity) active += 1

          else noActivity += 1

        } else {

          unknown += 1

        }

        if (entry.noClosure) noClosure += 1

      })

      const total = positionMap.size

      return {

        total,

        active,

        closed,

        open,

        unknown,

        noActivity,

        noClosure,

      }

    },

    canDownloadReport() {

      return this.$can('download', 'statuswise_report')

        || this.$can('download', 'report')

        || this.$can('read', 'statuswise_report')

        || this.$can('read', 'report')

        || this.$can('manage', 'all')

    },

    isDownloadReady() {

      if (this.isComparisonMode) {

        return this.hasFetched && this.comparisonRows.length > 0

      }

      return this.hasFetched && (Boolean(this.downloadFile) || this.displayData.length > 0)

    },

    hasActiveFilters() {

      return this.activeFilterCount > 0

    },

    activeFilterCount() {

      let count = 0

      if (this.mgrSelected) count += 1

      if (this.recSelected) count += 1

      if (this.locSelected) count += 1

      if (this.clientSelected) count += 1

      if (this.sourceSelected) count += 1

      if (this.empStatusSelected) count += 1

      if (this.verticalSelected) count += 1

      if (this.categorySelected) count += 1

      if (!this.arraysEqual(this.selected, DEFAULT_DIMENSIONS)) count += 1

      if (this.showDetailedColumns) count += 1

      if (!this.arraysEqual(this.statusSelected, DEFAULT_STATUS_SELECTED)) count += 1

      return count

    },

  },

  watch: {

    clientSelected(value) {

      if (value && !this.selected.includes('position_name')) {

        this.selected = [...this.selected, 'position_name']

      }

    },

    verticalSelected() {

      this.reapplyComparisonFilters()

    },

    categorySelected() {

      this.reapplyComparisonFilters()

    },

  },

  created() {

    const today = moment().locale('en')

    this.startDate = today.clone().startOf('week').add(1, 'days').format('YYYY-MM-DD')

    this.endDate = today.clone().endOf('week').format('YYYY-MM-DD')



    UserService.getAllUsersDd().then(res => {

      if (res.status === 'OK') {

        this.recruiters = res.data.filter(item => item.role === 'talent-advisor-sourcer' || item.role === 'account-manager' || item.role === 'talent-advisor')

        this.accountMgr = res.data.filter(item => item.role === 'account-manager')

      }

    })



    clientService.getClients().then(res => {

      this.clients = res.data

    })

  },

  mounted() {

    adminConfigService.getATSDropdownList().then(res => {

      if (res.status === 200) {

        this.sources = res.data.data.sourceList

      }

    })

    adminConfigService.getJobsDropdownList().then(res => {

      const payload = res && res.data && res.data.data

      if (!payload) return

      if (Array.isArray(payload.verticalList) && payload.verticalList.length) {

        this.verticalOptions = payload.verticalList

      }

      if (Array.isArray(payload.categoryList) && payload.categoryList.length) {

        this.categoryOptions = payload.categoryList

      }

    }).catch(() => {})

  },

  methods: {

    normalizeFilterValue(value) {

      return String(value || '').trim().toLowerCase()

    },

    arraysEqual(a, b) {

      if (!Array.isArray(a) || !Array.isArray(b)) return false

      if (a.length !== b.length) return false

      const sortedA = [...a].sort()

      const sortedB = [...b].sort()

      return sortedA.every((val, idx) => val === sortedB[idx])

    },

    formatDisplayDate(value) {

      if (!value) return '—'

      return moment(value).format('DD MMM YYYY')

    },

    numVal(value) {

      const n = Number(value)

      return Number.isFinite(n) ? n : 0

    },

    // Interview: use API field when present; else sum interview-stage statuses (backend TODO for dedicated field)

    getInterviewCount(row) {

      if (row.Interview != null && row.Interview !== '') {

        return this.numVal(row.Interview)

      }

      return this.numVal(row.ScreenSelect)

        + this.numVal(row.InProcess)

        + this.numVal(row.Inprocess)

        + this.numVal(row.Confirmed)

        + this.numVal(row.NoShow)

    },

    // Revenue: backend field not confirmed — show em dash until API provides it

    getRevenue(row) {

      if (row.Revenue != null && row.Revenue !== '') return row.Revenue

      if (row.revenue != null && row.revenue !== '') return row.revenue

      return '—'

    },

    getRowDate(row) {

      const raw = pickRowActivityDate(row)

      if (!raw) return ''

      return this.formatDisplayDate(raw)

    },

    getRowSource(row) {

      return pickRowSource(row)

    },

    getPositionKey(row) {

      const name = row.PositionName || row.position_name || row.Position || ''

      const id = this.getRowJobId(row)

      if (name && id) return `${id}::${name}`

      return name || (id ? String(id) : '')

    },

    getRowJobId(row) {

      return row.job_id || row.JobId || row.JobID || row.position_id || row.PositionId || ''

    },

    normalizePositionName(name) {

      return String(name || '').trim().toLowerCase()

    },

    resolveJobMeta(row) {

      const jobId = this.getRowJobId(row)

      if (jobId && this.jobMetaByJobId[String(jobId)]) {

        return this.jobMetaByJobId[String(jobId)]

      }

      const name = row.PositionName || row.position_name || row.Position || ''

      const normalized = this.normalizePositionName(name)

      const clientKey = this.normalizePositionName(row.Client || this.formatJobClient(row.client) || '')

      if (normalized && clientKey && this.jobMetaByClientPosition[`${clientKey}::${normalized}`]) {

        return this.jobMetaByClientPosition[`${clientKey}::${normalized}`]

      }

      if (normalized && this.jobMetaByPositionName[normalized]) {

        return this.jobMetaByPositionName[normalized]

      }

      return null

    },

    formatJobClient(client) {

      if (!client) return ''

      if (typeof client === 'string') return client

      if (Array.isArray(client) && client[0]) {

        return client[0].title || client[0].name || String(client[0])

      }

      if (client.title) return client.title

      if (client.name) return client.name

      return String(client)

    },

    getRowClient(row) {

      if (row.Client) return row.Client

      const meta = this.resolveJobMeta(row)

      return meta ? this.formatJobClient(meta.client) : ''

    },

    formatPositionExport(row) {

      const name = row.PositionName || '—'

      if (!this.selected.includes('position_name')) return name

      const bits = [name]

      if (row.PositionStatus) bits.push(row.PositionStatus)

      if (row.NoClosure) bits.push('No closure')

      return bits.join('\n')

    },

    formatClientJobBlock(row) {

      const lines = []

      const client = this.getRowClient(row) || row.Client || ''

      if (client) lines.push(client)

      if (!this.selected.includes('position_name')) {

        return lines.join('\n') || '—'

      }

      if (row.JobIdDisplay) lines.push(`Job #${row.JobIdDisplay}`)

      if (row.PositionCreatedDate) lines.push(`Created ${row.PositionCreatedDate}`)

      if (row.DaysOpen != null) {

        lines.push(`${row.DaysOpen} day${row.DaysOpen === 1 ? '' : 's'} open`)

      }

      return lines.join('\n') || '—'

    },

    getPositionCreatedRaw(row) {

      if (row._positionCreatedRaw) return row._positionCreatedRaw

      const fromRow = row.position_created_date

        || row.created_at

        || row.createdAt

        || row.job_created

        || row.JobCreated

      if (fromRow) return fromRow

      const meta = this.resolveJobMeta(row)

      if (!meta) return null

      return meta.createdAt || meta.created_at || null

    },

    getDaysOpen(createdRaw) {

      if (!createdRaw) return null

      const created = moment(createdRaw)

      if (!created.isValid()) return null

      return moment().diff(created, 'days')

    },

    hasNoClosure(row) {

      if (this.numVal(row.Joined) > 0) return false

      if (this.isPositionClosed(row) === true) return false

      const days = this.getDaysOpen(this.getPositionCreatedRaw(row))

      return days != null && days > NO_CLOSURE_DAYS_THRESHOLD

    },

    resolveAtsJobStatus(row) {

      if (Object.prototype.hasOwnProperty.call(row, '_atsJobStatus')) return row._atsJobStatus

      const fromRow = row.position_status

        || row.JobStatus

        || row.job_status

        || row.Status

        || row.status

        || row.PositionStatus

        || ''

      if (fromRow) return fromRow

      const meta = this.resolveJobMeta(row)

      if (meta && meta.status) return meta.status

      return ''

    },

    getRawPositionStatus(row) {

      return this.resolveAtsJobStatus(row)

    },

    formatStatusLabel(value) {

      const text = String(value).trim()

      if (!text) return 'Unknown'

      const lower = text.toLowerCase()

      if (lower === 'active' || lower === 'approval pending') return 'Open'

      if (lower === 'closed') return 'Closed'

      if (lower === 'on hold' || lower === 'onhold') return 'On Hold'

      if (lower === 'cancelled') return 'Cancelled'

      if (lower === 'draft') return 'Draft'

      if (lower === 'target date breached' || lower === 'targetdatebreached') return 'Target Breached'

      if (/^open$/i.test(text)) return 'Open'

      if (/closed/i.test(text)) return 'Closed'

      if (/hold/i.test(text)) return 'On Hold'

      if (/cancel/i.test(text)) return 'Cancelled'

      if (/active/i.test(text)) return 'Open'

      return text

    },

    isPositionClosed(row) {

      if (row.IsClosed === true || row.is_closed === true) return true

      if (row.IsClosed === false || row.is_closed === false) return false

      const raw = this.getRawPositionStatus(row)

      if (!raw) return null

      const normalized = String(raw).toLowerCase().trim()

      if (

        normalized === 'closed'

        || normalized === 'cancelled'

        || normalized.includes('target date breached')

        || normalized.includes('targetdatebreached')

        || normalized.includes('target breached')

      ) return true

      if (

        normalized === 'active'

        || normalized === 'approval pending'

        || normalized === 'open'

        || normalized === 'draft'

        || normalized.includes('hold')

      ) return false

      return null

    },

    hasPipelineActivity(row) {

      if (row.IsActive === true || row.is_active === true) return true

      if (row.IsActive === false || row.is_active === false) return false

      return PIPELINE_ACTIVITY_KEYS.some(key => this.numVal(row[key]) > 0)

    },

    getPositionStatusLabel(row) {

      const raw = this.getRawPositionStatus(row)

      if (raw) return this.formatStatusLabel(raw)

      return 'Unknown'

    },

    getWorkingStatusLabel(row) {

      if (this.isPositionClosed(row) === true) return 'Closed'

      if (this.hasPipelineActivity(row)) return 'Active'

      if (this.isPositionClosed(row) === false) return 'No activity'

      return 'Unknown status'

    },

    positionStatusVariant(row) {

      const label = row.PositionStatus || ''

      if (label === 'Closed' || label === 'Cancelled' || label === 'Target Breached') return 'light-secondary'

      if (label === 'On Hold') return 'light-warning'

      if (label === 'Open' || label === 'Draft') return 'light-success'

      if (label === 'Unknown') return 'light-warning'

      return 'light-secondary'

    },

    workingStatusVariant(row) {

      const label = row.WorkingStatus || ''

      if (label === 'Active') return 'light-success'

      if (label === 'Closed') return 'light-secondary'

      if (label === 'No activity') return 'light-warning'

      if (label === 'Unknown status') return 'light-warning'

      return 'light-secondary'

    },

    togglePositionStatusFilter(filter) {

      this.positionStatusFilter = this.positionStatusFilter === filter ? null : filter

    },

    needsJobMeta() {

      return this.selected.includes('position_name')

        || this.selected.includes('vertical')

        || this.selected.includes('category')

        || Boolean(this.verticalSelected)

        || Boolean(this.categorySelected)

        || (this.isComparisonMode && this.comparisonPositionWise)

    },

    applyJobMetaCache() {

      if (!jobMetaCache.fetchedAt) return

      this.jobMetaByJobId = jobMetaCache.byJobId

      this.jobMetaByPositionName = jobMetaCache.byName

      this.jobMetaByClientPosition = jobMetaCache.byClientPosition || {}

    },

    hydrateJobMetaFromRows(rows) {

      const byJobId = { ...this.jobMetaByJobId }

      const byName = { ...this.jobMetaByPositionName }

      const byClientPosition = { ...this.jobMetaByClientPosition }

      rows.forEach(row => {

        const meta = {

          status: row.PositionStatus || row.position_status || row.status,

          createdAt: row.position_created_date || row.createdAt || row.created_at,

          client: row.Client || row.client,

          job_id: row.job_id || row.JobId,

          position_name: row.Position || row.PositionName || row.position_name,

          vertical: row.Vertical || row.vertical,

          category: row.Category || row.category,

        }

        if (meta.job_id) byJobId[String(meta.job_id)] = { ...byJobId[String(meta.job_id)], ...meta }

        const normalized = this.normalizePositionName(meta.position_name)

        if (!normalized) return

        byName[normalized] = { ...byName[normalized], ...meta }

        const clientKey = this.normalizePositionName(this.formatJobClient(meta.client) || meta.client)

        if (clientKey) byClientPosition[`${clientKey}::${normalized}`] = { ...byClientPosition[`${clientKey}::${normalized}`], ...meta }

      })

      this.jobMetaByJobId = byJobId

      this.jobMetaByPositionName = byName

      this.jobMetaByClientPosition = byClientPosition

    },

    reapplyComparisonFilters() {

      if (!this.isComparisonMode || !this._comparisonCurrentMapped) return

      const currentMapped = this.applyVerticalCategoryFilter(this._comparisonCurrentMapped)

      const previousMapped = this.applyVerticalCategoryFilter(this._comparisonPreviousMapped || [])

      this.comparisonRows = this.buildComparisonFromMapped(currentMapped, previousMapped)

    },

    applyVerticalCategoryFilter(rows) {

      const vertical = this.normalizeFilterValue(this.verticalSelected)

      const category = this.normalizeFilterValue(this.categorySelected)

      if (!vertical && !category) return rows

      return rows.filter(row => {

        if (vertical && this.normalizeFilterValue(row.Vertical) !== vertical) return false

        if (category && this.normalizeFilterValue(row.Category) !== category) return false

        return true

      })

    },

    async enrichJobStatuses(rows) {

      if (!Array.isArray(rows) || !rows.length || !this.needsJobMeta()) return

      if (trackerRowsHaveJobFields(rows)) {

        this.hydrateJobMetaFromRows(rows)

        return

      }

      if (jobMetaCache.fetchedAt && (Date.now() - jobMetaCache.fetchedAt) < JOB_META_TTL_MS) {

        this.applyJobMetaCache()

        return

      }

      if (jobMetaInflight) {

        await jobMetaInflight

        this.applyJobMetaCache()

        return

      }

      const scopeUser = resolveJobScopeUser(this)

      jobMetaInflight = JobService.getActiveJobs(scopeUser, 2000, 1, ATS_JOB_STATUSES)

        .then(res => {

          if (res.status !== 'OK' || !Array.isArray(res.data)) return

          const byJobId = {}

          const byName = {}

          const byClientPosition = {}

          res.data.forEach(job => {

            const meta = {

              status: job.status,

              createdAt: job.createdAt || job.created_at,

              client: job.client,

              job_id: job.job_id,

              position_name: job.position_name,

              vertical: job.vertical,

              category: job.category,

            }

            if (job.job_id) byJobId[String(job.job_id)] = meta

            const normalized = this.normalizePositionName(job.position_name)

            if (!normalized) return

            byName[normalized] = meta

            const clientKey = this.normalizePositionName(this.formatJobClient(job.client))

            if (clientKey) byClientPosition[`${clientKey}::${normalized}`] = meta

          })

          jobMetaCache = { byJobId, byName, byClientPosition, fetchedAt: Date.now() }

          this.applyJobMetaCache()

        })

        .catch(() => {})

        .finally(() => {

          jobMetaInflight = null

        })

      await jobMetaInflight

    },

    getDisplayMetricKeys() {

      const keys = new Set([

        'TotalCandidates',

        'ProfileShared',

        'Interview',

        'Shortlisted',

        'Offered',

        'NotOffered',

        'OfferDrop',

        'NotOfferedDrop',

        'Joined',

        ...PIPELINE_ACTIVITY_KEYS,

        ...DETAILED_STATUS_COLUMNS.map(col => col.key),

      ])

      return [...keys]

    },

    formatJoinedNames(names) {

      const seen = new Set()

      const unique = []

      ;(names || []).forEach(n => {

        const cleaned = normalizePersonName(n)

        if (!cleaned) return

        const key = cleaned.toLowerCase()

        if (seen.has(key)) return

        seen.add(key)

        unique.push(cleaned)

      })

      return unique.join(', ')

    },

    aggregateDisplayRows(rows, mode) {

      if (!Array.isArray(rows) || !rows.length) return []

      const metricKeys = this.getDisplayMetricKeys()

      const groups = new Map()

      rows.forEach(row => {

        const client = this.getRowClient(row) || row.Client || 'Unknown'

        let key

        const datePart = this.selected.includes('date') ? (row.Date || this.getRowDate(row) || '') : ''

        const sourcePart = this.selected.includes('source') ? (this.getRowSource(row) || row.Source || '') : ''

        const vertPart = this.selected.includes('vertical') ? (row.Vertical || '') : ''

        const catPart = this.selected.includes('category') ? (row.Category || '') : ''

        if (mode === 'selected') {

          key = [

            this.selected.includes('date') ? datePart : '',

            this.selected.includes('client') ? client : '',

            this.selected.includes('position_name') ? (this.getPositionKey(row) || row.PositionName || '') : '',

            this.selected.includes('recruiter') ? normalizePersonName(row.Recruiter).toLowerCase() : '',

            this.selected.includes('manager') ? (row.Manager || '') : '',

            this.selected.includes('location') ? (row.Location || '') : '',

            this.selected.includes('source') ? sourcePart : '',

            vertPart,

            catPart,

          ].join('\u0000')

        } else if (mode === 'client') {

          key = `client::${client}\u0000${datePart}\u0000${sourcePart}\u0000${vertPart}\u0000${catPart}`

        } else {

          const posKey = this.getPositionKey(row) || row.PositionName || row.position_name || ''

          key = `cp::${client}\u0000${posKey}\u0000${datePart}\u0000${sourcePart}\u0000${vertPart}\u0000${catPart}`

        }

        if (!groups.has(key)) {

          const base = { ...row }

          metricKeys.forEach(k => {

            base[k] = 0

          })

          base._recruiters = []

          base._managers = []

          base._locations = []

          base._sources = []

          base._revenueSum = 0

          base._revenueHas = false

          base._daysOpenMax = null

          base._createdRawMin = null

          base._anyNoClosure = false

          base._positionStatuses = []

          if (mode === 'client' || (mode === 'selected' && !this.selected.includes('position_name'))) {

            base.PositionName = ''

            base.JobIdDisplay = ''

            base.PositionCreatedDate = ''

            base.DaysOpen = null

            base.PositionStatus = ''

            base.NoClosure = false

          }

          groups.set(key, base)

        }

        const agg = groups.get(key)

        metricKeys.forEach(k => {

          agg[k] = this.numVal(agg[k]) + this.numVal(row[k])

        })

        if (row.Recruiter) agg._recruiters.push(row.Recruiter)

        if (row.Manager) agg._managers.push(row.Manager)

        if (row.Location) agg._locations.push(row.Location)

        const sourceName = this.getRowSource(row) || row.Source

        if (sourceName) agg._sources.push(sourceName)

        if (this.selected.includes('date') && (row.Date || datePart) && !agg.Date) {

          agg.Date = row.Date || datePart

        }

        if (this.selected.includes('source') && sourceName && !agg.Source) {

          agg.Source = sourceName

        }

        const rev = row.Revenue

        if (rev != null && rev !== '' && rev !== '—') {

          const n = Number(rev)

          if (Number.isFinite(n)) {

            agg._revenueSum += n

            agg._revenueHas = true

          }

        }

        if (row.DaysOpen != null) {

          const d = this.numVal(row.DaysOpen)

          if (agg._daysOpenMax == null || d > agg._daysOpenMax) agg._daysOpenMax = d

        }

        const createdRaw = row._positionCreatedRaw || this.getPositionCreatedRaw(row)

        if (createdRaw) {

          if (!agg._createdRawMin || moment(createdRaw).isBefore(agg._createdRawMin)) {

            agg._createdRawMin = createdRaw

          }

        }

        if (row.NoClosure) agg._anyNoClosure = true

        if (row.PositionStatus) agg._positionStatuses.push(row.PositionStatus)

        // Prefer an open/non-closed status label when merging

        if (mode !== 'client' && row.PositionStatus && (!agg.PositionStatus || agg.PositionStatus === 'Unknown')) {

          agg.PositionStatus = row.PositionStatus

        } else if (mode !== 'client' && row.PositionStatus === 'Open') {

          agg.PositionStatus = 'Open'

        }

        if (mode !== 'client') {

          if (!agg.JobIdDisplay && row.JobIdDisplay) agg.JobIdDisplay = row.JobIdDisplay

          if (!agg.PositionName && row.PositionName) agg.PositionName = row.PositionName

          if (!agg.Client && client) agg.Client = client

        } else {

          agg.Client = client

        }

        if (this.selected.includes('vertical') && row.Vertical && !agg.Vertical) agg.Vertical = row.Vertical

        if (this.selected.includes('category') && row.Category && !agg.Category) agg.Category = row.Category

      })

      return [...groups.values()].map(agg => {

        agg.Recruiter = this.formatJoinedNames(agg._recruiters)

        agg.Manager = this.formatJoinedNames(agg._managers)

        agg.Location = this.formatJoinedNames(agg._locations)

        agg.Source = this.formatJoinedNames(agg._sources)

        agg.NotOfferedDrop = this.numVal(agg.NotOffered) + this.numVal(agg.OfferDrop)

        agg.Revenue = agg._revenueHas ? agg._revenueSum : '—'

        if (mode === 'client' || (mode === 'selected' && !this.selected.includes('position_name'))) {

          agg.PositionName = ''

          agg.PositionStatus = ''

          agg.JobIdDisplay = ''

          agg.PositionCreatedDate = ''

          agg.DaysOpen = null

          agg.NoClosure = false

        } else {

          if (agg._createdRawMin) {

            agg._positionCreatedRaw = agg._createdRawMin

            agg.PositionCreatedDate = this.formatDisplayDate(agg._createdRawMin)

            agg.DaysOpen = this.getDaysOpen(agg._createdRawMin)

          } else if (agg._daysOpenMax != null) {

            agg.DaysOpen = agg._daysOpenMax

          }

          agg.NoClosure = this.numVal(agg.Joined) > 0 ? false : agg._anyNoClosure

        }

        delete agg._recruiters

        delete agg._managers

        delete agg._locations

        delete agg._sources

        delete agg._revenueSum

        delete agg._revenueHas

        delete agg._daysOpenMax

        delete agg._createdRawMin

        delete agg._anyNoClosure

        delete agg._positionStatuses

        return agg

      })

    },

    mapRow(row) {

      const meta = this.resolveJobMeta(row)

      const createdRaw = this.getPositionCreatedRaw(row)

      const mapped = {

        ...row,

        Date: this.getRowDate(row),

        Source: this.getRowSource(row) || this.sourceSelected || '',

        PositionName: row.PositionName || row.position_name || row.Position || '',

        Recruiter: pickRowRecruiter(row),

        Client: row.Client || (meta ? this.formatJobClient(meta.client) : ''),

        Interview: this.showDetailedColumns ? pickStatusCount(row, 'Interview') : this.getInterviewCount(row),

        NotOfferedDrop: this.numVal(pickStatusCount(row, 'NotOffered') || row.NotOffered) + this.numVal(pickStatusCount(row, 'OfferDrop') || row.OfferDrop),

        Revenue: this.getRevenue(row),

      }

      DETAILED_STATUS_COLUMNS.forEach(col => {

        if (col.key === 'Interview' && !this.showDetailedColumns) return

        mapped[col.key] = pickStatusCount(row, col.key)

      })

      mapped._positionCreatedRaw = createdRaw

      mapped.PositionCreatedDate = createdRaw ? this.formatDisplayDate(createdRaw) : ''

      mapped.DaysOpen = this.getDaysOpen(createdRaw)

      mapped.JobIdDisplay = this.getRowJobId(row) || (meta ? meta.job_id : '')

      mapped._atsJobStatus = this.resolveAtsJobStatus(row)

      mapped.PositionStatus = mapped._atsJobStatus

        ? this.formatStatusLabel(mapped._atsJobStatus)

        : 'Unknown'

      mapped.NoClosure = this.hasNoClosure(mapped)

      mapped.Vertical = row.Vertical || row.vertical || (meta && meta.vertical) || ''

      mapped.Category = row.Category || row.category || (meta && meta.category) || ''

      return mapped

    },

    getDownloadFilename() {

      if (this.isComparisonMode && this.comparisonPeriods) {

        const { current, previous } = this.comparisonPeriods

        return buildReportFilename(

          'Status_Wise_Week_Comparison',

          `${current.start}_vs_${previous.start}`,

          current.end,

        )

      }

      return this.filename || buildReportFilename('Status_Wise_Tracker', this.startDate, this.endDate)

    },

    hasPositionExportMeta() {

      if ((this.selected || []).includes('position_name')) return true

      if (this.displayGroupingMode === 'client_position') return true

      return this.displayData.some(row => (

        row.JobIdDisplay

        || row.PositionCreatedDate

        || row.DaysOpen != null

        || row.PositionName

      ))

    },

    getStatusWiseExportFields() {

      const selected = this.selected || []

      const includePositionMeta = this.hasPositionExportMeta()

      const fields = []

      const pushIf = (cond, key, label) => {

        if (cond) fields.push({ key, label })

      }

      pushIf(selected.includes('date'), 'Date', 'Date')

      pushIf(selected.includes('client') || includePositionMeta, 'Client', 'Client')

      pushIf(includePositionMeta, 'JobId', 'Job ID')

      pushIf(selected.includes('position_name') || includePositionMeta, 'PositionName', 'Position')

      pushIf(selected.includes('vertical'), 'Vertical', 'Vertical')

      pushIf(selected.includes('category'), 'Category', 'Category')

      pushIf(selected.includes('recruiter'), 'Recruiter', 'Recruiter')

      pushIf(selected.includes('manager'), 'Manager', 'Team Lead')

      pushIf(selected.includes('location'), 'Location', 'Location')

      pushIf(selected.includes('source'), 'Source', 'Source')

      pushIf(includePositionMeta, 'PositionStatus', 'Position Status')

      pushIf(includePositionMeta, 'DaysOpen', 'Days Open')

      pushIf(includePositionMeta, 'Created', 'Created')

      if (this.showDetailedColumns && this.detailedFields.length) {

        fields.push({ key: 'TotalCandidates', label: 'Total' })

        this.detailedFields.forEach(field => {

          fields.push({ key: field.key, label: field.label || field.key })

        })

        fields.push({ key: 'Revenue', label: 'Revenue' })

      } else {

        this.defaultMetricFields.forEach(field => {

          fields.push({

            key: field.key,

            label: field.key === 'TotalCandidates' ? 'Total' : field.label,

          })

        })

      }

      return fields

    },

    exportMetricValue(row, key) {

      if (key === 'Revenue') {

        const raw = row.Revenue

        if (raw == null || raw === '' || raw === '—') return ''

        const n = Number(raw)

        return Number.isFinite(n) ? n : ''

      }

      return this.numVal(row[key])

    },

    formatStatusWiseRowForExport(row) {

      const mapped = {

        Date: cleanExportText(row.Date || this.getRowDate(row), 'Date'),

        Client: cleanExportText(this.getRowClient(row) || row.Client, 'Client'),

        JobId: cleanExportJobId(row.JobIdDisplay || this.getRowJobId(row)),

        PositionName: cleanExportText(row.PositionName, 'Position'),

        Vertical: cleanExportText(row.Vertical, 'Vertical'),

        Category: cleanExportText(row.Category, 'Category'),

        Recruiter: cleanExportText(row.Recruiter, 'Recruiter'),

        Manager: cleanExportText(row.Manager, 'Team Lead'),

        Location: cleanExportText(row.Location, 'Location'),

        Source: cleanExportText(this.getRowSource(row) || row.Source, 'Source'),

        PositionStatus: cleanExportText(row.PositionStatus, 'Position Status'),

        DaysOpen: cleanExportDaysOpen(row.DaysOpen),

        Created: cleanExportText(row.PositionCreatedDate, 'Created'),

      }

      if (mapped.Created === '—') mapped.Created = ''

      const metricFields = this.showDetailedColumns && this.detailedFields.length

        ? [{ key: 'TotalCandidates' }, ...this.detailedFields, { key: 'Revenue' }]

        : this.defaultMetricFields

      metricFields.forEach(field => {

        mapped[field.key] = this.exportMetricValue(row, field.key)

      })

      return mapped

    },

    downloadReport() {

      if (!this.canDownloadReport || !this.isDownloadReady) return

      const filename = this.getDownloadFilename()

      if (this.isComparisonMode && this.comparisonRows.length > 0) {

        exportTableToExcel({

          rows: this.comparisonRows.map(row => this.formatComparisonRowForExport(row)),

          fields: this.getComparisonExportFields(),

          filename,

          sheetName: 'Week Comparison',

          freezeHeader: true,

        })

        return

      }

      if (this.displayData.length > 0) {

        exportTableToExcel({

          rows: this.displayData.map(row => this.formatStatusWiseRowForExport(row)),

          fields: this.getStatusWiseExportFields(),

          filename,

          sheetName: 'Status Wise',

          freezeHeader: true,

        })

        return

      }

      if (this.downloadFile) {

        downloadBase64Excel(this.downloadFile, filename)

      }

    },

    setReportMode(mode) {

      if (this.reportMode === mode) return

      this.reportMode = mode

      this.reportStatus = ''

      this.hasFetched = false

      this.compiledData = []

      this.comparisonRows = []

      this.comparisonPeriods = null

      this.comparisonPositionWise = false

      this.downloadFile = ''

      this.filename = ''

      this.positionStatusFilter = null

    },

    formatComparisonCell(value) {

      if (value == null) return '—'

      return value

    },

    formatComparisonDelta(change) {

      return formatDeltaValue(change)

    },

    formatComparisonDeltaPct(changePct) {

      return formatDeltaPct(changePct)

    },

    async onComparisonGroupByChange(value) {

      if (value == null || value === this.comparisonGroupBy) return

      const previousGroupBy = this.comparisonGroupBy

      const previousPositionWise = this.comparisonPositionWise

      if (value === 'client') {

        const result = await this.$bvModal.msgBoxConfirm(

          'Do you want to view position-wise data?',

          {

            title: 'By client view',

            size: 'sm',

            buttonSize: 'sm',

            okVariant: 'primary',

            okTitle: 'Yes',

            cancelTitle: 'No',

            footerClass: 'p-2',

            centered: true,

            hideHeaderClose: true,

            noCloseOnBackdrop: true,

            noCloseOnEsc: true,

          },

        )

        // Yes → true (position-wise); No → false (client totals). Dialog forces a choice.

        this.comparisonGroupBy = 'client'

        this.comparisonPositionWise = Boolean(result)

      } else {

        this.comparisonGroupBy = value

        this.comparisonPositionWise = false

      }

      const viewChanged = (

        previousGroupBy !== this.comparisonGroupBy

        || previousPositionWise !== this.comparisonPositionWise

      )

      if (viewChanged && this.hasFetched && this.isComparisonMode) {

        this.getComparisonReport()

      }

    },

    comparisonDeltaClass(change) {

      const variant = deltaVariant(change, true)

      if (variant === 'success') return 'report-comparison-delta--up'

      if (variant === 'danger') return 'report-comparison-delta--down'

      return 'report-comparison-delta--neutral'

    },

    getComparisonMetricChange(row, metricKey) {

      return row ? row[`${metricKey}__change`] : null

    },

    showComparisonInlineDelta(row, metricKey) {

      if (!row || row.rowType !== 'current') return false

      return row[`${metricKey}__change`] != null || row[`${metricKey}__changePct`] != null

    },

    formatComparisonInlineDelta(row, metricKey) {

      return formatInlineDelta(row[`${metricKey}__change`], row[`${metricKey}__changePct`])

    },

    getComparisonExportFields() {

      if (this.comparisonGroupBy !== 'client') {

        return this.comparisonTableFields

      }

      const fields = [

        { key: 'groupLabel', label: 'Client' },

      ]

      if (this.comparisonPositionWise) {

        fields.push({ key: 'positionLabel', label: 'Position' })

      }

      fields.push({ key: 'weekLabel', label: 'Week' })

      COMPARISON_METRICS.forEach(metric => {

        fields.push(

          { key: metric.key, label: metric.label },

          { key: `${metric.key}__change`, label: `${metric.label} Δ` },

          { key: `${metric.key}__changePct`, label: `${metric.label} Δ%` },

        )

      })

      return fields

    },

    formatComparisonRowForExport(row) {

      if (this.comparisonGroupBy === 'client') {

        const mapped = {

          groupLabel: row.groupLabel,

          weekLabel: row.weekLabel,

        }

        if (this.comparisonPositionWise) {

          mapped.positionLabel = row.positionLabel

        }

        COMPARISON_METRICS.forEach(metric => {

          mapped[metric.key] = this.formatComparisonCell(row[metric.key])

          if (row.rowType === 'current') {

            mapped[`${metric.key}__change`] = this.formatComparisonDelta(row[`${metric.key}__change`])

            mapped[`${metric.key}__changePct`] = this.formatComparisonDeltaPct(row[`${metric.key}__changePct`])

          } else {

            mapped[`${metric.key}__change`] = ''

            mapped[`${metric.key}__changePct`] = ''

          }

        })

        return mapped

      }

      return {

        ...row,

        current: this.formatComparisonCell(row.current),

        previous: this.formatComparisonCell(row.previous),

        change: this.formatComparisonDelta(row.change),

        changePct: this.formatComparisonDeltaPct(row.changePct),

      }

    },

    getComparisonMetricValue(row, metricKey) {

      if (metricKey === 'Revenue') {

        const raw = row.Revenue

        if (raw == null || raw === '' || raw === '—') return null

        return this.numVal(raw)

      }

      return this.numVal(row[metricKey])

    },

    getComparisonPositionLabel(row) {

      return row.PositionName || row.position_name || row.Position || '—'

    },

    buildComparisonFromMapped(currentMapped, previousMapped) {

      const getMetric = (row, key) => this.getComparisonMetricValue(row, key)

      if (this.comparisonGroupBy === 'client') {

        const periods = this.comparisonPeriods || {}

        const current = periods.current || getMonSatWeekRange()

        const previous = periods.previous || getPreviousWeekRange(current.start, current.end)

        const currentWeekLabel = formatComparisonPeriodRange(current.start, current.end)

        const previousWeekLabel = formatComparisonPeriodRange(previous.start, previous.end)

        const weekOpts = {

          includePosition: this.comparisonPositionWise,

          currentWeekLabel,

          previousWeekLabel,

        }

        if (this.comparisonPositionWise) {

          const currentByGroup = aggregateByClientPosition(

            currentMapped,

            row => this.getRowClient(row),

            row => this.getComparisonPositionLabel(row),

            getMetric,

          )

          const previousByGroup = aggregateByClientPosition(

            previousMapped,

            row => this.getRowClient(row),

            row => this.getComparisonPositionLabel(row),

            getMetric,

          )

          return buildWeekWiseComparisonRows(currentByGroup, previousByGroup, weekOpts)

        }

        const currentByClient = aggregateByClient(

          currentMapped,

          row => this.getRowClient(row),

          getMetric,

        )

        const previousByClient = aggregateByClient(

          previousMapped,

          row => this.getRowClient(row),

          getMetric,

        )

        return buildWeekWiseComparisonRows(currentByClient, previousByClient, weekOpts)

      }

      const currentTotals = aggregateOverall(currentMapped, getMetric)

      const previousTotals = aggregateOverall(previousMapped, getMetric)

      return buildOverallComparisonRows(currentTotals, previousTotals)

    },

    buildTrackerRequestParams() {

      const forceClient = this.isComparisonMode && this.comparisonGroupBy === 'client'

      const forcePosition = forceClient && this.comparisonPositionWise

      const forcePositionForFilters = Boolean(
        this.verticalSelected
        || this.categorySelected
        || this.selected.includes('vertical')
        || this.selected.includes('category'),
      )

      return {

        rec: this.selected.includes('recruiter'),

        mgr: this.selected.includes('manager'),

        loc: this.selected.includes('location'),

        client: this.selected.includes('client') || forceClient,

        source: this.selected.includes('source'),

        position: this.selected.includes('position_name') || forcePosition || forcePositionForFilters,

        date: this.selected.includes('date'),

        recSel: this.recSelected || '',

        mgrSel: this.mgrSelected || '',

        locSel: this.locSelected || '',

        sourceSel: this.sourceSelected || '',

        clientSel: this.clientSelected || '',

        empStatusSel: this.empStatusSelected || '',

        verticalSel: this.verticalSelected || '',

        categorySel: this.categorySelected || '',

        groupVertical: this.selected.includes('vertical'),

        groupCategory: this.selected.includes('category'),

        groupSource: this.selected.includes('source'),

        groupDate: this.selected.includes('date'),

        detailed: this.showDetailedColumns,

        statuses: this.showDetailedColumns ? (this.statusSelected || []) : [],

        groupBy: this.selected.join(','),

      }

    },

    fetchTrackerData(startDate, endDate, overrides = {}) {

      const params = { ...this.buildTrackerRequestParams(), ...overrides }

      return reportService.getStatusWiseTracker(

        startDate,

        endDate,

        params.rec,

        params.mgr,

        params.loc,

        params.client,

        params.source,

        params.position,

        params.date,

        params.recSel,

        params.mgrSel,

        params.clientSel,

        params.locSel,

        params.sourceSel,

        params.empStatusSel,

        params.verticalSel,

        params.categorySel,

        {

          groupVertical: params.groupVertical,

          groupCategory: params.groupCategory,

          groupSource: params.groupSource,

          groupDate: params.groupDate,

          detailed: params.detailed,

          statuses: params.statuses,

          groupBy: params.groupBy,

        },

      )

    },

    getConfiguredSourceNames() {

      const list = Array.isArray(this.sources) ? this.sources : []

      const names = list.map(item => {

        if (!item) return ''

        if (typeof item === 'string') return item.trim()

        return String(item.title || item.name || item.value || '').trim()

      }).filter(Boolean)

      return [...new Set(names)]

    },

    trackerRowsFromResponse(res) {

      return (res && res.status === 'OK' && Array.isArray(res.data)) ? res.data : []

    },

    async mapTrackerBatches(items, batchSize, mapper) {

      const out = []

      const size = Math.max(1, batchSize || 6)

      for (let i = 0; i < items.length; i += size) {

        const chunk = items.slice(i, i + size)

        const part = await Promise.all(chunk.map(mapper))

        part.forEach(rows => {

          if (Array.isArray(rows) && rows.length) out.push(...rows)

        })

      }

      return out

    },

    async fanOutTrackerBySources(startDate, endDate) {

      const sources = this.getConfiguredSourceNames()

      if (!sources.length) return []

      return this.mapTrackerBatches(sources, 6, async source => {

        const res = await this.fetchTrackerData(startDate, endDate, { sourceSel: source })

        return this.trackerRowsFromResponse(res).map(row => ({ ...row, Source: pickRowSource(row) || source }))

      })

    },

    async fanOutTrackerByDates(startDate, endDate, sourceSel) {

      const days = listDateRangeDays(startDate, endDate)

      if (!days.length) return []

      const overrides = sourceSel ? { sourceSel } : {}

      return this.mapTrackerBatches(days, 7, async day => {

        const res = await this.fetchTrackerData(day, day, overrides)

        return this.trackerRowsFromResponse(res).map(row => ({

          ...row,

          Date: pickRowActivityDate(row) || day,

          ...(sourceSel ? { Source: pickRowSource(row) || sourceSel } : {}),

        }))

      })

    },

    async hydrateGroupDimensions(startDate, endDate, rows) {

      let next = Array.isArray(rows) ? rows.slice() : []

      const wantSource = this.selected.includes('source')

      const wantDate = this.selected.includes('date')

      if (!wantSource && !wantDate) return next

      if (!next.length) return next

      if (wantSource && this.sourceSelected && !rowsHaveSourceValues(next)) {

        next = next.map(row => ({ ...row, Source: this.sourceSelected }))

      }

      if (wantDate && startDate && startDate === endDate && !rowsHaveActivityDates(next)) {

        next = next.map(row => ({ ...row, Date: startDate }))

      }

      const needSource = wantSource && !rowsHaveSourceValues(next)

      const needDate = wantDate && !rowsHaveActivityDates(next)

      if (!needSource && !needDate) return next

      try {

        if (needSource && needDate) {

          const sources = this.getConfiguredSourceNames()

          const days = listDateRangeDays(startDate, endDate)

          if (sources.length && days.length && (sources.length * days.length) <= 120) {

            const pairs = []

            sources.forEach(source => days.forEach(day => pairs.push({ source, day })))

            return this.mapTrackerBatches(pairs, 6, async ({ source, day }) => {

              const res = await this.fetchTrackerData(day, day, { sourceSel: source })

              return this.trackerRowsFromResponse(res).map(row => ({

                ...row,

                Source: pickRowSource(row) || source,

                Date: pickRowActivityDate(row) || day,

              }))

            })

          }

          if (days.length) return this.fanOutTrackerByDates(startDate, endDate)

          return this.fanOutTrackerBySources(startDate, endDate)

        }

        if (needSource) return this.fanOutTrackerBySources(startDate, endDate)

        return this.fanOutTrackerByDates(startDate, endDate)

      } catch (err) {

        console.log(err)

        return next

      }

    },

    clampReportDateRange() {

      if (!this.startDate || !this.endDate) return ''

      const start = moment(this.startDate)

      const end = moment(this.endDate)

      if (!start.isValid() || !end.isValid()) return ''

      if (end.diff(start, 'days') <= MAX_REPORT_RANGE_DAYS) return ''

      this.startDate = end.clone().subtract(MAX_REPORT_RANGE_DAYS, 'days').format('YYYY-MM-DD')

      return `Date range limited to ${MAX_REPORT_RANGE_DAYS} days for performance. Start date adjusted to ${this.formatDisplayDate(this.startDate)}.`

    },

    handleTrackerAuthFailure() {

      window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])

      this.reportStatus = 'Session expired. Redirecting to login…'

      localStorage.clear()

      this.$router.push({ name: 'auth-login' })

    },

    getComparisonReport() {

      const thisWeek = getMonSatWeekRange()

      const lastWeek = getPreviousWeekRange(thisWeek.start, thisWeek.end)

      this.comparisonPeriods = { current: thisWeek, previous: lastWeek }

      this.loading = true

      this.reportStatus = ''

      return Promise.all([

        this.fetchTrackerData(thisWeek.start, thisWeek.end),

        this.fetchTrackerData(lastWeek.start, lastWeek.end),

      ]).then(([currentRes, previousRes]) => {

        if (currentRes.status === 401 || currentRes.status === 403

          || previousRes.status === 401 || previousRes.status === 403) {

          this.handleTrackerAuthFailure()

          return

        }

        if (currentRes.status !== 'OK' || previousRes.status !== 'OK') {

          this.reportStatus = 'An error occurred loading comparison data. Please try again or contact IT admin.'

          this.comparisonRows = []

          return

        }

        return Promise.all([

          this.hydrateGroupDimensions(thisWeek.start, thisWeek.end, this.trackerRowsFromResponse(currentRes)),

          this.hydrateGroupDimensions(lastWeek.start, lastWeek.end, this.trackerRowsFromResponse(previousRes)),

        ]).then(([currentData, previousData]) => {

        const enrichRows = currentData.concat(previousData)

        const waitForMeta = Boolean(this.verticalSelected || this.categorySelected)

        const enrichPromise = this.enrichJobStatuses(enrichRows)

        const applyMapped = () => {

          this._comparisonCurrentMapped = currentData.map(row => this.mapRow(row))

          this._comparisonPreviousMapped = previousData.map(row => this.mapRow(row))

          this.reapplyComparisonFilters()

          if (!this.comparisonRows.length) {

            this.reportStatus = 'No data found for comparison periods.'

          }

        }

        if (waitForMeta) return enrichPromise.then(applyMapped)

        applyMapped()

        return enrichPromise.then(applyMapped).catch(() => {})

        })

      }).catch(() => {

        this.reportStatus = 'Failed to load comparison report. Please try again.'

        this.comparisonRows = []

      }).finally(() => {

        this.hasFetched = true

        this.loading = false

      })

    },

    getReport() {

      this.compiledData = []

      this.comparisonRows = []

      this.hasFetched = false

      this.downloadFile = ''

      this.filename = ''

      this.positionStatusFilter = null

      if (jobMetaCache.fetchedAt) this.applyJobMetaCache()

      if (this.isComparisonMode) {

        return this.getComparisonReport()

      }

      if (this.startDate === '' || this.endDate === '') {

        this.reportStatus = 'Please select start and end dates.'

        return

      }

      const rangeNote = this.clampReportDateRange()

      this.rangeWarning = rangeNote



      this.loading = true

      this.reportStatus = ''



      const todayStr = moment().locale('en').format('YYYY-MM-DD')

      if (new Date(this.startDate) <= new Date(todayStr) && new Date(this.startDate) <= new Date(this.endDate)) {

        this.fetchTrackerData(this.startDate, this.endDate).then(async res => {

          this.hasFetched = true

          if (res.status === 'OK') {

            this.reportStatus = ''

            this.compiledData = await this.hydrateGroupDimensions(

              this.startDate,

              this.endDate,

              this.trackerRowsFromResponse(res),

            )

            this.filename = res.filename || ''

            this.downloadFile = res.file || ''

            const waitForMeta = Boolean(this.verticalSelected || this.categorySelected)

            const enrichPromise = this.enrichJobStatuses(this.compiledData)

            const finish = () => {

              if (!this.compiledData.length) {

                this.reportStatus = rangeNote || 'No data found for selected dates.'

              }

              this.loading = false

            }

            if (waitForMeta) return enrichPromise.then(finish).catch(finish)

            enrichPromise.catch(() => {})

            finish()

            return

          } else if (res.status === 401 || res.status === 403) {

            this.handleTrackerAuthFailure()

          } else if (res.status === 400) {

            this.reportStatus = 'An error occurred. Please try again or contact IT admin.'

            this.compiledData = []

          } else if (res.status === 500) {

            this.reportStatus = `Error: ${(res.data && res.data.message) || 'Server error.'} Kindly contact IT admin.`

            this.compiledData = []

          }

          this.loading = false

        }).catch(() => {

          this.hasFetched = true

          this.loading = false

          this.reportStatus = 'Failed to load report. Please try again.'

          this.compiledData = []

        })

      } else if (new Date(this.startDate) > new Date(this.endDate)) {

        this.loading = false

        this.hasFetched = true

        this.reportStatus = 'Start date cannot be greater than end date.'

      } else {

        this.loading = false

        this.hasFetched = true

        this.reportStatus = 'Start date cannot be greater than today.'

      }

    },

  },

}

</script>



<style lang="scss">

@import '@core/scss/vue/libs/vue-flatpicker.scss';

@import '@core/scss/vue/apps/report-tracker.scss';

</style>



<style scoped>

.report-v-select {

  min-width: 0;

}

.report-dimension-purpose {

  font-size: 0.8125rem;

  line-height: 1.45;

  color: #b9b9c3;

  margin: -0.5rem 0 0.875rem;

}

.report-position-chip {

  font-size: 0.9375rem;

  font-weight: 600;

}

.report-position-chip--filter {

  cursor: pointer;

}

.report-position-chip--active {

  box-shadow: 0 0 0 2px rgba(115, 103, 240, 0.35);

}

.report-position-chip--clear {

  font-weight: 500;

}

.report-status-help-icon {

  vertical-align: middle;

  color: #b9b9c3;

}

.report-position-badges {

  display: flex;

  flex-wrap: wrap;

  align-items: center;

  gap: 0.25rem;

  margin-top: 0.2rem;

}

.report-status-badge {

  font-size: 0.8125rem;

  font-weight: 600;

  letter-spacing: 0.01em;

}

.report-job-hierarchy {

  display: flex;

  flex-direction: column;

  gap: 0.125rem;

  min-width: 0;

}

.report-job-client-name {

  font-weight: 600;

  color: #5e5873;

}

.report-job-id,

.report-job-created {

  font-size: 0.875rem;

  color: #b9b9c3;

  line-height: 1.35;

}

.report-job-days-open {

  font-size: 0.875rem;

  color: #b9b9c3;

  line-height: 1.35;

}

.report-job-days-open--stale {

  color: #ea5455;

  font-weight: 600;

}

.report-job-position-name {

  font-weight: 600;

  color: #5e5873;

}

.report-recruiter-name {

  display: block;

  max-width: 14rem;

  overflow: hidden;

  text-overflow: ellipsis;

  white-space: nowrap;

}

::v-deep th.report-recruiter-col,
::v-deep td.report-recruiter-col {

  min-width: 10.5rem;

  white-space: nowrap;

}

.report-no-closure-badge {

  align-self: flex-start;

  font-size: 0.75rem;

  font-weight: 600;

}

</style>


